import { useContext } from 'react';

import { ConfirmDialogContext } from '@components/ui/ConfirmDialog/ConfirmDialogContext';

export function useConfirm() {
  const confirm = useContext(ConfirmDialogContext);
  if (!confirm) {
    throw new Error('useConfirm must be used within ConfirmDialogProvider');
  }
  return confirm;
}
